<template>
  <div class="SidebarElementDropdownButton" ref="dropdown" :class="activeDropdownClass" :id="getRandomID()" @click.stop="toggleDropdown($event.target, 'SidebarElementDropdownButton')">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
      <g fill="currentColor">
        <circle cx="6" cy="12" r="1.5"></circle>
        <circle cx="12" cy="12" r="1.5"></circle>
        <circle cx="18" cy="12" r="1.5"></circle>
      </g>
    </svg>
  </div>
</template>

<script>
import ELYXUtils from "../ELYXUtils";
import { ELYXCentralStore } from "../../ELYX/ELYXStore";

export default {
  computed: {
    activeDropdown: () => ELYXCentralStore.state.activeDropdown,
    activeDropdownClass() {
      if (!this.activeDropdown || !this.activeDropdown.id || !this.$refs.dropdown.id) return;
      return this.activeDropdown.id === this.$refs.dropdown.id ? "SidebarElementDropdownButton--active" : "";
    },
  },
  methods: {
    toggleDropdown: (event, dropdownName) => {
      ELYXCentralStore.methods.setDropdown(event, dropdownName);
    },
    getRandomID: ELYXUtils.getRandomStringID,
  },
};
</script>

<style>
.SidebarElementDropdownButton {
  cursor: pointer;
  display: none;
  width: 16px;
  height: 16px;
  padding: 3px;
  margin-right: 8px;
  margin-left: 2px;
  border-radius: 8px;
  flex-shrink: 0;
}
.SidebarElementDropdownButton:hover,
.SidebarElementDropdownButton--active {
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 5%), 0 9px 24px rgb(213 213 213 / 20%);
}
.SidebarElementDropdownButton--active {
  display: block;
}
</style>
